import { render, staticRenderFns } from "./CreateAICallLogModal.vue?vue&type=template&id=03639914&"
import script from "./CreateAICallLogModal.vue?vue&type=script&lang=js&"
export * from "./CreateAICallLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports